var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340.37 121.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed5338;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334,.05c-30.16,4-47.19,7.08-70.4,10.57l-.15,0-.27,0a3.84,3.84,0,0,0-.64.18l-.18.08-.14.07c-2.86,1.31-3.94,5.25-1.74,8.38l12.16,17.22Q256.6,48,240.48,59.38q-31.8,22.33-63.79,44.42c-5.32-26.35-10.46-52.74-16.22-79-.93-4.25-5.41-6.61-9.19-4.11-30.13,19.92-121.15,73.36-150,95-3.19,2.39.34,6.72,3.66,4.94,29.69-15.91,109.71-64,145.75-86,5.08,26.67,10.7,53.26,16,79.89.88,4.4,5.71,6.91,9.57,4.27q35.91-24.55,71.55-49.51,16-11.23,32-22.57l12.41,17.58c2.22,3.14,6.85,2,8.72-.5,13.51-18.11,26.33-36.72,38.64-55.67C342,4.42,338.54-.55,334,.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesArrow);
export default __webpack_public_path__ + "static/media/sales_arrow.d672e391981175a1283048f23759f173.svg";
export { ForwardRef as ReactComponent };